module Client.Home.UpdateEmail

open Client
open Elmish
open Shared
open Illy.SafeStack.Client
open System
open Illy.SafeStack
open Fable.React 
open Shared.Home.UpdateEmail

type Model = 
    {
        OldEmail: string
        Email: Text.Model
        Password: Text.Model
        Saving: bool
    }

let toDTO (model: Model) = 
    {
        Email = Text.toString model.Email
        Password = Text.toString model.Password
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Shared.Home.UpdateEmail.Validations

    let resetValidations (model: Model) = 
        {model with 
            Email = Text.resetValidations model.Email
            Password = Text.resetValidations model.Password
        }

    let dispatchValidations model = 
        let model = resetValidations model 
        function 
        | ValidationResult.Passed -> model 
        | ValidationResult.Warned _ -> failwith "Did not expect warnings"
        | ValidationResult.Failed (err, _) ->
            let errors = 
                err 
                |> ValidationInfrastructure.bundleValidations 
                    (fun x -> 
                        (match x with 
                        | EmailAddressValidations _ -> 0 
                        | PasswordValidations _ -> 1), UpdateEmailValidations.toString x)
                    2
            {model with 
                Email = Text.setValidations model.Email errors.[0] None
                Password = Text.setValidations model.Password errors.[1] None
            }

type Msg = 
    | ApiError of ApiError
    | SaveResult of ROP.Result<ClientSideUser, FailureReason>
    | EmailMsg of Text.Msg
    | PasswordMsg of Text.Msg
    | CloseOverlay  
    | SaveClicked 

type Event = 
    | CloseOverlay 
    | ApiError of ApiError
    | SaveSuccessful of updatedUser: ClientSideUser * notification: string 

module Initialisations = 
    let initEmail value =
        Text.CustomSettings.defaultOptions()
        |> Text.init "Email" "New Email Address" (Some "Enter Email Address") 250. true value

    let initPassword value =
        { Text.CustomSettings.defaultOptions() with TextType = Text.TextType.Password }
        |> Text.init "Password" "Password" (Some "Enter Password") 250. true value

let init () = 
    let u = Storage.get<ClientSideUser> Storage.USER_STORAGE_KEY
    {
        OldEmail = u.EmailAddress
        Email = Initialisations.initEmail None
        Password = Initialisations.initPassword None
        Saving = false
    }, []

let update msg model = 
    match msg with 
    | EmailMsg cMsg ->
        let m, c = Text.update cMsg model.Email
        {model with Email = m}, Cmd.map EmailMsg c |> SideEffect.Cmd
    | PasswordMsg cMsg ->
        let m, c = Text.update cMsg model.Password
        {model with Password = m}, Cmd.map PasswordMsg c |> SideEffect.Cmd
    | Msg.ApiError err -> model, err |> ApiError |> SideEffect.Event 
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event 
    | SaveClicked -> 
        let dto = toDTO model 
        let vResult = Validations.validateDTO model.OldEmail dto
        if Validation.isSuccessful false vResult then 
            {model with Saving = true},
            Api.secureCall<IUpdateEmailApi,_,_,_> SecuredRoute.Standard (fun api -> api.updateEmail) dto SaveResult Msg.ApiError |> SideEffect.Cmd
        else 
            Validations.dispatchValidations model vResult, SideEffect.none
    | SaveResult result -> 
        match result with 
        | ROP.Success u ->
            model, (u, "Email Address was updated successfully.") |> Event.SaveSuccessful |> SideEffect.Event
        | ROP.Failure (FailedValidations v) ->
            Validations.dispatchValidations {model with Saving = false} v, SideEffect.none

let view model dispatch = 
    jQueryUI.modal "Update Email Address" 50 Msg.CloseOverlay dispatch (Some 600) [
        p [] [
            str "Your current email address is: "
            b [] [
                model.OldEmail |> str
            ] 
        ]

        Text.text false model.Email (EmailMsg >> dispatch)
        Text.text false model.Password (PasswordMsg >> dispatch)

        yield! UI.saveControls (Some "Update email address") false model.Saving SaveClicked Msg.CloseOverlay dispatch
    ]